import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const RelatedResources = ({
  title = "Related Tools & Services",
  subtitle,
  items,
  testId = "related-resources",
}) => {
  if (!items || items.length === 0) return null;
  return (
    <section className="bg-slate-50 section-padding" data-testid={testId}>
      <div className="container-custom">
        <div className="mb-6">
          <h2 className="text-2xl md:text-3xl font-semibold text-navy font-heading">{title}</h2>
          {subtitle && <p className="text-slate-600 text-sm md:text-base mt-1">{subtitle}</p>}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {items.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="group bg-white border border-slate-200 hover:border-gold rounded-xl px-5 py-4 inline-flex items-start justify-between gap-3 transition-colors"
              data-testid={`${testId}-link-${item.to.replace(/\//g, "-")}`}
            >
              <div className="flex-1 min-w-0">
                {item.tag && (
                  <span className="inline-block text-[10px] font-bold uppercase tracking-wider text-gold mb-1">
                    {item.tag}
                  </span>
                )}
                <p className="text-navy font-semibold text-sm group-hover:text-gold transition-colors">
                  {item.label}
                </p>
                {item.description && (
                  <p className="text-slate-500 text-xs mt-1">{item.description}</p>
                )}
              </div>
              <ArrowRight size={16} className="text-slate-400 group-hover:text-gold flex-shrink-0 mt-0.5 transition-colors" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedResources;
